import $$ from 'cmn-utils'
const baseUrl = "/api/datav/common/";
export default {
    totalAlarm: (params) => {
        return $$.get(baseUrl + 'total-alarm', params)
    },
    totalBase: (params) => {
        return $$.get(baseUrl + 'total-base', params)
    },
    totalDevice: (params) => {
        return $$.get(baseUrl + 'total-device', params)
    },
    totalDeviceInstall: (params) => {
        return $$.get(baseUrl + 'total-device-install', params)
    },
    totalOrder: (params) => {
        return $$.get(baseUrl + 'total-order', params)
    },
    totalProductDevice: (params) => {
        return $$.get(baseUrl + 'total-product-device', params)
    },
    totalUnitCategory: (params) => {
        return $$.get(baseUrl + 'total-unit-category', params)
    },
}